import { Text } from "@/components/Typography/Text";
import { cn } from "@/lib/cn";
import { type VariantProps, cva } from "class-variance-authority";
// src/apps/app/src/components/StatusCount/StatusCount.tsx
import { HStack } from "../Layout";

const statusCountVariants = cva("items-baseline w-fit", {
  variants: {
    variant: {
      success: "text-success-on-neutral-fill",
      neutral: "text-neutral-on-fill",
      warning: "text-warning-on-neutral-fill",
      error: "text-error-on-neutral-fill",
      muted: "text-neutral-muted-on-fill",
    },
    size: {
      default: "",
      small: "",
    },
  },
  defaultVariants: {
    variant: "success",
    size: "default",
  },
});

export interface StatusCountProps
  extends VariantProps<typeof statusCountVariants> {
  /** 現在の値（割り当て数） */
  current: number;
  /** 全体の値 */
  total: number;
  /** 追加のCSSクラス */
  className?: string;
  /** データテスト用ID */
  "data-testid"?: string;
}

export function StatusCount({
  current,
  total,
  variant = "success",
  size = "default",
  className,
  "data-testid": testId,
}: StatusCountProps) {
  const clampedCurrent = Math.max(current, 0);
  const clampedTotal = Math.max(total, 0);

  const currentVariant = size === "default" ? "labelLarge" : "label";
  const totalVariant = size === "default" ? "labelSemiLarge" : "labelSmallReg";

  return (
    <HStack
      className={cn(statusCountVariants({ variant, size }), className)}
      data-testid={testId}
    >
      <Text variant={currentVariant}>{clampedCurrent}</Text>
      <Text variant={totalVariant} className="text-neutral-muted-on-fill">
        /{clampedTotal}
      </Text>
    </HStack>
  );
}
